import React, { FC } from 'react';
import { FormControl, Select, MenuItem, SelectChangeEvent, InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

type RoleFilterProps = {
    roleSelected: (role: string) => void;
    fullWidth?: boolean;
};
const RoleFilter: FC<RoleFilterProps> = ({ roleSelected, fullWidth }: RoleFilterProps) => {
    const { t: translate } = useTranslation(['common', 'users']);

    const handleStatusSelect = (event: SelectChangeEvent<string>) => {
        if (event.target.value === 'Show all') {
            return roleSelected('');
        }
        if (event.target.value === 'user') {
            return roleSelected('user');
        }
        if (event.target.value === 'DENTIST_USER') {
            return roleSelected('DENTIST_USER');
        }
        if (event.target.value === 'DENTIST_ADMIN') {
            return roleSelected('DENTIST_ADMIN');
        }
    };
    return (
        <FormControl margin="dense" fullWidth={fullWidth} style={{ minWidth: 150 }}>
            <InputLabel>{translate('common:ROLE')}</InputLabel>
            <Select defaultValue={'Show all'} label={translate('common:SHOW_ALL')} onChange={handleStatusSelect}>
                <MenuItem value={'user'}>{translate('common:USER')}</MenuItem>
                <MenuItem value={'DENTIST_USER'}>{translate('common:DENTIST_USER')}</MenuItem>
                <MenuItem value={'DENTIST_ADMIN'}>{translate('common:DENTIST_ADMIN')}</MenuItem>
                <MenuItem value={'Show all'}>{translate('common:SHOW_ALL')}</MenuItem>
            </Select>
        </FormControl>
    );
};

export default RoleFilter;
